import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyQueries} from '../../api'
import type {RiaDetailsAuditLogEntryDto} from '../../types'

import {riskSurveyQueryKeys} from './riskSurveyQueryKeys'

export const useRiaDetailsAuditLog = (
  riaId: string,
  options?: Omit<UseQueryOptions<RiaDetailsAuditLogEntryDto[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<RiaDetailsAuditLogEntryDto[], AxiosError>({
    queryKey: riskSurveyQueryKeys.rias.detailsAuditLog(riaId),
    queryFn: ({signal}) => riskSurveyQueries.getRiaDetailsAuditLog(riaId, signal),
    enabled: !!riaId,
    staleTime: 60_000,
    gcTime: 300_000,
    ...options
  })
}
